import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  organizations: []
}

// getters
export const getters = {
  organizations: state => state.organizations,
}

// mutations
export const mutations = {
  [types.DELETE_ORGANIZATIONS_SUCCESS] (state, organizations) {
    Object.keys(organizations).filter(key => organizations[key] == 1).forEach((id) => {
      const organization = state.organizations.find(organization => organization.id == id);
      const index = state.organizations.indexOf(organization);
      state.organizations.removeAt(index);
    });
  },

  [types.DELETE_ORGANIZATIONS_FAILURE] (state) {
    state.organizations = [];
  },

  [types.FETCH_ORGANIZATIONS_SUCCESS] (state, { organizations }) {
    state.organizations = organizations;
  },

  [types.FETCH_ORGANIZATIONS_FAILURE] (state) {
    state.organizations = [];
  },
}

// actions
export const actions = {
  async fetchOrganizations ({ commit }) {
    try {
      const response = await axios.get(`/api/organizations`)

      commit(types.FETCH_ORGANIZATIONS_SUCCESS, { organizations: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_ORGANIZATIONS_FAILURE)
    }
  },

  async deleteOrganizations ({ commit }, organizations) {
    try {
      return new Promise(async (resolve, reject) => {
        const response = await axios.delete('/api/organizations', { data: organizations })
          .then(response => {
            commit(types.DELETE_ORGANIZATIONS_SUCCESS, response.data);
            resolve(response);
          })
          .catch(error => reject(error))
        });
    } catch (error) {
      console.error(error)
      commit(types.DELETE_ORGANIZATIONS_FAILURE)
    }
  },
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/organizations.js